<template>
  <main class="content container">
    <div class="content__top">

      <div class="content__row">
        <h1 class="content__title">
          Каталог
        </h1>
        <span class="content__info">
          <img src="../../public/img/Spinner-pink.svg" v-if="countProductsAllLoading">
          {{ countProductsAll }} товаров
        </span>
      </div>
    </div>

    <div class="content__catalog">
      <ProductFilter :price-from.sync="filterPriceFrom" :price-to.sync="filterPriceTo"
        :category-id.sync="filterCategoryId" :material-ids.sync="filterMaterialIds" :season-ids.sync="filterSeasonIds"
        :color-ids.sync="filterColorIds" />

      <section class="catalog">

        <div class="productsLoading" v-if="productsLoading">
          <p class="productsLoading_text">Загрузка товаров ...</p>
          <img src="../../public/img/Spinner-pink.svg">
        </div>
        <div class="productsLoadingFailed" v-else-if="productsLoadingFailed">
          <p>Произошла ошибка при загрузке товаров</p>
          <button @click.prevent="loadProducts">Попробовать еще раз</button>
        </div>
        <div v-else-if="products.length != 0">
          <ProductList :products="products" />
          <BasePagination v-model="page" :count="countProducts" :per-page="productsPerPage" />
        </div>
        <div v-else class="products-not-found">Товары не найдены</div>
      </section>
    </div>
  </main>
</template>

<script>
import ProductList from '@/components/ProductList.vue';
import BasePagination from '@/components/BasePagination.vue';
import ProductFilter from '@/components/ProductFilter.vue';
import axios from 'axios';
import { API_BASE_URL } from "@/config";

export default {
  components: { ProductList, BasePagination, ProductFilter },
  data() {
    return {
      filterPriceFrom: 0,
      filterPriceTo: 0,
      filterCategoryId: 0,
      filterMaterialIds: [],
      filterSeasonIds: [],
      filterColorIds: [],

      countProductsAll: null,
      page: 1,
      productsPerPage: 12,
      productsData: null,
      productsLoading: false,
      productsLoadingFailed: false,
      countProductsAllLoading: false,
    };
  },
  computed: {

    products() {
      return this.productsData
        ? this.productsData.items.map(product => {
          return {
            ...product,
          }
        })
        : [];
    },
    countProducts() {
      return this.productsData ? this.productsData.pagination.total : 0;
    },
  },
  methods: {
    loadProductsAll() {
      this.countProductsAllLoading = true;
      clearTimeout(this.loadCountProductsAllTimer);
      this.loadCountProductsAllTimer = setTimeout(() => {
        axios
          .get(API_BASE_URL + `/api/products`)
          .then(response => this.countProductsAll = response.data.items.length)
          .then(() => this.countProductsAllLoading = false);
      }, 2000);
    },
    loadProducts() {
      this.productsLoading = true;
      this.productsLoadingFailed = false;
      clearTimeout(this.loadProductsTimer);
      this.loadProductsTimer = setTimeout(() => {
        axios
          .get(API_BASE_URL + `/api/products`, {
            params: {
              categoryId: this.filterCategoryId,
              materialIds: Object.keys(this.filterMaterialIds),
              seasonIds: Object.keys(this.filterSeasonIds),
              colorIds: Object.keys(this.filterColorIds),
              page: this.page,
              limit: this.productsPerPage,
              minPrice: this.filterPriceFrom,
              maxPrice: this.filterPriceTo
            }
          })
          .then(response => {
            this.productsData = response.data,
              this.productsData.items.forEach(item => {
                item.colors.forEach(color => {
                  if (color.color.code == "#ffffff") {
                    color.color.code = "#F0F0F0"
                  }
                })
              })
          })
          .catch(() => this.productsLoadingFailed = true)
          .then(() => this.productsLoading = false);
      }, 2000);
    },
    categoryRouter() {
      if (this.$route.query.category) {
        this.filterCategoryId = Number(this.$route.query.category)
      }
    }
  },
  watch: {
    page() {
      this.loadProducts();
    },
    filterPriceFrom() {
      this.loadProducts();
    },
    filterPriceTo() {
      this.loadProducts();
    },
    filterCategoryId() {
      this.loadProducts();
    },
    filterColorIds() {
      this.loadProducts();
    },
    filterMaterialIds() {
      this.loadProducts();
    },
    filterSeasonIds() {
      this.loadProducts();
    },

  },
  created() {
    this.categoryRouter();
    this.loadProductsAll();
    this.loadProducts();
  }
};
</script>

<style>
.catalog__pic img {
  object-fit: contain;
}

.productsLoading,
.productsLoadingFailed {
  margin: 0 auto;
}

.productsLoading img {
  display: block;
  margin: 0 auto;
}

.productsLoading_text,
.productsLoadingFailed p {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.productsLoadingFailed button {
  background-color: #e02d71;
  border: none;
  color: white;
  padding: 25px 15px;
  text-align: center;
  text-decoration: none;
  display: block;
  font-size: 13px;
  margin: 0 auto;
}

.content__info img {
  width: 16px;
}

.products-not-found {
  margin: 0 auto;
}
</style>
